// extracted by mini-css-extract-plugin
export default {"container":"TournamentWrapper_container__MWbon"};